import React, { useState } from "react";
import DashboardSettingsHeader from "./DashboardSettingsHeader";
import { BackIcon, ButtonArrowIcon } from "../../_assets/icons";
import FormButton from "../../../app/modules/Auth/Components/FormButton";
import propTypes from "prop-types";
import { useIntl } from "react-intl";
import { useFormik } from "formik";
import * as Yup from "yup";
import FormInput from "../../../app/modules/Auth/Components/FormInput";
import { changePassword } from "../../../app/modules/Auth/_redux/authCrud";

const initialValues = {
  currentPassword: "",
  newPassword: "",
  newPasswordConfirmation: ""
};

const getScheme = intl => {
  return Yup.object().shape({
    currentPassword: Yup.string().required(
      intl.formatMessage({ id: "THIS_FIELD_REQUIRED" })
    ),
    newPassword: Yup.string()
      .min(
        8,
        intl.formatMessage({
          id: "NEW_PASSWORD_INPUT_PLACEHOLDER"
        })
      )
      .max(
        12,
        intl.formatMessage({
          id: "NEW_PASSWORD_INPUT_PLACEHOLDER"
        })
      )
      .required(intl.formatMessage({ id: "THIS_FIELD_REQUIRED" })),
    newPasswordConfirmation: Yup.string()
      .required(intl.formatMessage({ id: "THIS_FIELD_REQUIRED" }))
      .oneOf(
        [Yup.ref("newPassword")],
        intl.formatMessage({ id: "PASSWORD_NOT_MATCH" })
      )
  });
};
DashboardChangePasswordFirstPage.propTypes = {
  iconOnClick: propTypes.func.isRequired,
  changePage: propTypes.func.isRequired
};

function DashboardChangePasswordFirstPage(props) {
  const intl = useIntl();
  const formik = useFormik({
    initialValues,
    validationSchema: getScheme(intl),
    onSubmit: (values, { setStatus, setSubmitting }) => {
      changePassword(values)
        .then(props.changePage)
        .catch(err => {
          props.setToastMenu({
            status: true,
            descText: err?.response?.data?.errorMessage,
            headerText: intl.formatMessage({ id: "REQUEST_FAILED" }),
            isWarning: true
          });
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  });

  return (
    <div className="dashboard-form-area">
      <DashboardSettingsHeader
        icon={<BackIcon />}
        iconOnClick={props.iconOnClick}
        title={intl.formatMessage({ id: "CHANGE_PASSWORD" })}
        desc={
          <p
            className="widget-freights-desc-text mt-5 ml-2"
            style={{ fontWeight: "500" }}
          >
            {intl.formatMessage({ id: "PLEASE_FILL_FOLLOWING_INFORMATION" })}
          </p>
        }
      />

      <div className="mt-10 ml-5">
        <FormInput
          title={intl.formatMessage({ id: "ENTER_CURRENT_PASSWORD" })}
          inputType="password"
          inputName="currentPassword"
          placeHolder={intl.formatMessage({ id: "ENTER_CURRENT_PASSWORD" })}
          isRequired
          error={{
            status: Boolean(formik.errors.currentPassword),
            message: formik.errors.currentPassword
          }}
          {...formik.getFieldProps("currentPassword")}
        />
        <FormInput
          title={intl.formatMessage({ id: "ENTER_NEW_PASSWORD" })}
          inputType="password"
          inputName="newPassword"
          placeHolder={intl.formatMessage({
            id: "ENTER_NEW_PASSWORD"
          })}
          isRequired
          error={{
            status: Boolean(formik.errors.newPassword),
            message: formik.errors.newPassword
          }}
          {...formik.getFieldProps("newPassword")}
        />
        <FormInput
          title={intl.formatMessage({ id: "CONFIRM_PASSWORD_INPUT" })}
          inputType="password"
          inputName="newPasswordConfirmation"
          placeHolder={intl.formatMessage({
            id: "CONFIRM_PASSWORD_INPUT"
          })}
          isRequired
          error={{
            status: Boolean(formik.errors.newPasswordConfirmation),
            message: formik.errors.newPasswordConfirmation
          }}
          {...formik.getFieldProps("newPasswordConfirmation")}
        />
      </div>
      <div className="d-flex mt-10 ml-5 justify-content-end">
        <FormButton
          title={intl.formatMessage({ id: "UPDATE_PASSWORD" })}
          icon={<ButtonArrowIcon />}
          isDisabled={formik.isSubmitting || !formik.isValid}
          onClick={formik.handleSubmit}
        />
      </div>
    </div>
  );
}

export default DashboardChangePasswordFirstPage;
